import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Assignment, Create, Close, Add, Receipt } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'División', accessor: 'diviton' },
  { Header: 'Cód. Zona', accessor: 'base_zone_code' },
  { Header: 'Zona', accessor: 'base_zone_description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function CustomerPortfolio(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [customerPs, setCustomerPs] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function loadCustomerPs() {
    setDataLoading(true);
    let response = await wsGetAll('base/customer-portfolio');
    setDataLoading(false);
    if (response.success) setCustomerPs(response.data);
  }

  useEffect(() => {
    loadCustomerPs();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadCustomerPs} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIOS_STORE}
              component={
                <CardIcon color="primary">
                  <Receipt style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Carteras{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Carteras"
              defaultWidth={1200}
              indexRow={[0, 1, 3, 7]}
              widthRow={[120, 150, 150, 5]}
              columns={columns}
              data={customerPs.map((customerP, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIOS_UPDATE}
                      >
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(customerP)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIOS_DELETED}
                      >
                        <ButtonDelete
                          entity="base/customer-portfolio"
                          id={customerP.id}
                          reload={loadCustomerPs}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  code: customerP.code,
                  description: customerP.description,
                  diviton: customerP.divition.name,
                  base_zone_code: customerP.base_zone_code,
                  base_zone_description: customerP.base_zone_description,
                  state: customerP.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
